import {
  CanDeactivateFn
} from '@angular/router';
import {Observable} from 'rxjs';

/**
 * Components that need to offer a canDeactivate method to routing need to implement this interface.
 */
export interface CanComponentDeactivate {
  canDeactivate?: () => boolean | Observable<boolean>;
}

/**
 * Guard that handle components implementing {@link CanComponentDeactivate}.
 */

export const CanDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (component: CanComponentDeactivate) => {
  return component?.canDeactivate?.() ?? true;
};
